import { v4 as uuidV4 } from "uuid";
import sha256 from "./sha256.js";
import cookies from "./cookies.js";

const signPayload = (payload, userId) => {
    if (!userId) {
        let userCookie = cookies.getCookie("dm-ae-id");
        if (!userCookie) {
            userCookie = uuidV4();
            cookies.setCookie("dm-ae-id", userCookie);
        }
        userId = userCookie;
    }

    let strPayload = typeof(payload) === "string" ? payload : JSON.stringify(payload);

    return sha256().hex(`${strPayload}||${userId}`);
}

const crypto = { signPayload };

export default crypto;